webpackJsonp([272270418219529],{

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	var _StyledLink = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LegalNoticePage = function LegalNoticePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Legal Notice \u2022 ',
	        data.site.siteMetadata.title
	      )
	    ),
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _Typography.Title,
	        { fontSize: [4, 5], fontWeight: '7', lineHeight: 'title', mt: 0, mb: 3 },
	        'Legal Notice'
	      ),
	      _react2.default.createElement(_Typography.Rule, { mt: 4, mb: 5 })
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 0, mb: 3 },
	        'Information according to section 5 TMG and responsible for the content according to section 55 paragraph 2 RStV'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Dr. Lukas Pustina',
	        _react2.default.createElement('br', null),
	        'Kronenstra\xDFe 3',
	        _react2.default.createElement('br', null),
	        '53840 Troisdorf',
	        _react2.default.createElement('br', null),
	        'Deutschland'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Contact'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Telephone: +49 2241 881 7597',
	        _react2.default.createElement('br', null),
	        'E-Mail: info@pustina.de',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Online Dispute Resolution (ODR)'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'The European Commission offers a platform for the resolution of online disputes:',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://ec.europa.eu/consumers/odr',
	          text: 'https://ec.europa.eu/consumers/odr',
	          external: true
	        }),
	        '. You can find my E-Mail address in the contact section above. I do not engage in out-of-court settlements before consumer arbitration bodies.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Content Accountability'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'As service provider I am responsible for the content of this website according to section 7 paragraph 1 TMG. I am not obliged to monitor the transmitted or saved information of third parties or investigate circumstances pointing to illegal activity. My obligations to remove or block the use of content under generally applicable laws remain unaffected by this as per sections 8 to 10 TMG.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Link Accountability'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'My website contains links to third party websites. Only the providers of these third party websites are responsible for such linked content. No illegal content have been evident to me at the time of linking. I will remove the links as soon as I will be made aware of illegal content on linked website.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Copyright'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Unless expressly permitted by law, every form of utilizing, reproducing or processing works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights. Individual reproductions of a work are only allowed for private use. The materials from these pages are copyrighted and any unauthorized use may violate copyright laws.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'Quelle'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://www.e-recht24.de',
	          text: 'https://www.e-recht24.de',
	          external: true
	        }),
	        ' ',
	        'and',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'http://www.translate-24h.de',
	          text: '\xDCbersetzungsb\xFCro translate-24h.de',
	          external: true
	        })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = LegalNoticePage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legal-notice-js-910726e62b73cb2a8ed6.js